import React from 'react'
import classes from './Home.module.css'
import MetaTags from 'react-meta-tags';

function Home() {
    return (
        // <div className={classes.cursor}>
        <div className={classes.Headline}>
            <MetaTags>
              <title>Adarsh</title>
              <meta name="description" content="Some description." />
              <meta property="og:title" content="MyApp" />
              <meta property="og:image" content="path/to/image.jpg" />
            </MetaTags> 
            <div className={classes.head}>
                <h1 className={classes.head}>ADARSH KM</h1>
                <p>Full Stack Developer</p>
            </div>
        </div>
    )
}

export default Home